// @flow
import React from "react"
import {get} from "lodash"
import PropTypes from "prop-types"
import classNames from "classnames"

import Select from "@irati/ui/src/FormItem/Select"
import Form from "@irati/ui/src/Form"
import {injectIntl} from "@irati/utils/lang"

import "./Column.css"

const DONT_INCLUDE_COLUMN = {value: "dont_include", label: "admin.components.column.options.dontInclude"}

const defaultOptions = [
  {value: "firstName", label: "admin.components.column.options.firstName"},
  {value: "lastName", label: "admin.components.column.options.lastName"},
  {value: "email", label: "admin.components.column.options.emailAddress"},
  {value: "dateOfBirth", label: "admin.components.column.options.dateOfBirth"},
  {value: "employmentStartDate", label: "admin.components.column.options.employmentStartDate"},
  {value: "roles", label: "admin.components.column.options.roles"},
  {value: "teams", label: "admin.components.column.options.teams"},
  {value: "externalUserId", label: "admin.components.column.options.externalId"}
]

const RESOLVED_OPTIONS = (options, formatMessage) =>
  options.map((option) => {
    return {label: formatMessage({id: get(option, "label", "")}), value: get(option, "value", "")}
  })

// WARNING: This is actually not a bootstrap column,
// --> give proper name and move back to components
const Column = ({header, idx, changeHeader, options, formatMessage, children}) => {
  const className = classNames("csvColumn", {
    csvColumn_error: header,
    csvColumn_disabled: header === "dont_include"
  })

  return (
    <div className={className}>
      <Form>
        <Select
          value={header}
          placeholder={formatMessage({id: "admin.components.column.select.placeholder"})}
          isSearchable={false}
          isClearable={false}
          name={`header-${idx}`}
          onChange={(value) => {
            changeHeader(value, idx)
          }}
          options={RESOLVED_OPTIONS([DONT_INCLUDE_COLUMN, ...(options || defaultOptions)], formatMessage)}
        />
      </Form>
      {children}
    </div>
  )
}

Column.propTypes = {
  header: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  changeHeader: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  formatMessage: PropTypes.func.isRequired,
  options: PropTypes.array
}

export default injectIntl(Column)
